<template>
  <div class="notbox">
    <div class="notfount">
      <img src="~img/404@2x.png" alt="" />
      <p>诶嘛，网页找不到呢！</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped>
.notbox
    width 100%
    height 100vh
    background #fff
    padding-top 200px
    box-sizing border-box
.notfount
    width 518px
    height 300px
    margin auto
    img
        width 100%
    p
        font-size:14px;
        font-family:PingFangSC;
        font-weight:400;
        color:rgba(136,136,136,1);
        margin 30px 0 15px
        text-align center
</style>
